import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useSession from '../../hooks/stateHooks/useSession';
import BreadcrumbComponent from '../breadcrumb/BreadcrumbComponent';
import FooterComponent from '../footer/FooterComponent';
import MenuComponent from '../navigation/MenuComponent';

function MainPageComponent(props) {
    const _session = useSession();
    const navigate = useNavigate();

    useEffect(() => {
        if (props.requireAuthentication) {
            if (!_session.isLogged()) {
                navigate('/user/unauthorized');
            }
        }
    }, []);

    return (
        <div className="d-flex flex-grow flex-column align-items-stretch"
            style={{ minHeight: '100dvh', minWidth: '100dvw' }}>
            <MenuComponent ></MenuComponent>
            <BreadcrumbComponent path={props.path}></BreadcrumbComponent>
            <div className="d-flex flex-fill p-2" > {props.children} </div>
            <FooterComponent />
        </div>
    );
}

export default MainPageComponent;